import { render } from "./self-med.vue?vue&type=template&id=6297fe76&scoped=true"
const script = {}

import "./self-med.vue?vue&type=style&index=0&id=6297fe76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6297fe76"]])

export default __exports__